import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { CompanyButtons } from 'pages/custom/shared/detail/CompanyButtons';
import { S_PageStyle } from 'pages/page/PageStyle';
import { useContext, useEffect } from 'react';
import { CtxView } from 'session/ctxView';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const KDagPage = (props: Props): JSX.Element => {
    const ctxView = useContext(CtxView);

    function onMapLoad(e) {
        console.log('onLoad', e, ctxView);
        const mapRef = ctxView.mapRef;
        mapRef?.current?.getMap()?.setPaintProperty('background', 'background-color', '#F3F3F3');
    }

    useEffect(() => {
        ctxView.setCustomPageConfig({
            hideLogoInList: false
        });

        Localization.setLanguage('en');
    }, []);

    return (
        <S_KDagPage className={props.className}>
            <CustomMapPage
                mapId={'9c20f27c-74bf-46cf-9ce2-69babddb3d71'}
                header={{
                    logo: 'https://dvtqxks0zalev.cloudfront.net/f9c2f3b2-ef00-4ade-a3a3-a3210f5ec5ea.png',
                    logoText: 'KDag',
                    logoSubtext: 'Interaktivt kort',
                    link: 'https://konferencer.au.dk/kdag',
                    linkText: Localization.WEBSITE
                }}
                hideFloors
                controls={<CompanyButtons />}
                mapProps={{
                    onLoad: (e) => {
                        onMapLoad(e);
                    }
                }}
            />
        </S_KDagPage>
    );
};

const S_KDagPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
`;
